import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ivDecimalDirective]'
})
export class DecimalDirective {

  constructor(private el: ElementRef) {
  }


  @HostListener('focus')
  onFocus() {
    if (this.el.nativeElement.value === '0.00') {
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('blur')
  onBlur() {
    const val = this.el.nativeElement.value;
    if (val && isNaN(val)) {
      if (Number(val) % 1 === 0) {
        this.el.nativeElement.value = Number(val).toFixed(2);
      }
    }
  }
}
